import Api, { PostResponse } from '@/store/api';
import { upperFirst } from 'lodash';
import moment from 'moment';

declare type ModelState = { [key : string] : string[] }

export default class BaseApi {
    protected api : Api

    protected modelState : ModelState | null = null;

    constructor(apiName : string, formName ?: string) {
        this.api = new Api(apiName, formName);
    }

    getModelError(field : string | void) : string[] {
        let errors : string[];
        if (this.modelState != null) {
            if (field) {
                if (field in this.modelState) {
                    errors = this.modelState[field];
                } else if (upperFirst(field) in this.modelState) {
                    errors = this.modelState[upperFirst(field)];
                } else {
                    errors = ["Er is een onbekende fout opgetreden"];
                }
            } else {
                // Geef alle errors
                errors = Object.values(this.modelState).flat();
            }
        } else {
            errors = ["Er is een onbekende fout opgetreden"];
        }
        return errors;
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('YYYY-MM-DD');
    }

    protected isSuccess<T>(response : PostResponse<T> | void) : boolean {
        if (!response) return false;
        if (response.isSuccess) {
            return true;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }
}
